$('#entries, #library-page #entries').change(function () {
    this.form.submit();
});

$('#library-page #name').change(function () {
    $("#library-page #size").val([]);
    $("#library-page #date").val([]);
    this.form.submit();
});

$('#library-page #size').change(function () {
    $("#library-page #date").val([]);
    $("#library-page #name").val([]);
    this.form.submit();
});

$('body').on('mouseenter ', '.w-dropdown .course-icon-wrap, .action-menu .course-icon-wrap', function () {
    $(this).next().addClass('w--open');
});

$(document.body).on('mouseleave', '.dropdown-list.w-dropdown-list.w--open', function () {
    $('.dropdown-list').removeClass('w--open');
});
$(document.body).on('mouseleave', '.action-menu', function () {
    $('.dropdown-list').removeClass('w--open');
});
$(document.body).on('mouseleave', '.w-dropdown', function () {
    $('.dropdown-list').removeClass('w--open');
});


$('#library-page #date').change(function () {
    $("#library-page #size").val([]);
    $("#library-page #name").val([]);
    this.form.submit();
});

$('#course-filter, #author-filter, #status-filter, #category-filter').change(function () {
    this.form.submit();
});

$('#only_pending_essays').click(function () {
    this.form.submit();
})

$(document.body).on('click', '.essay-open', function () {
    let id = $(this).data('id');
    $('#essay-detail-' + id).toggle();
});


$('#goTopBtn').click(function () {
    $(window).scrollTop(0);
});

$('#mobile-menu-icon').click(function () {
    $('.w-nav-overlay').css('display', 'block');
});
$('#close-mobile-menu-icon').click(function () {
    $('.w-nav-overlay').css('display', 'none');
});

//CSS IMPROVED VERSION? CRISTIAN WAs here -> extended VIEW
// function adjustWidth() {
//     let width = $(document).width();
//     if (width > 767) {
//         var parentwidth = $(".fixed-parent").width();
//         $(".fixed").width(parentwidth);
//     }
// }

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

// $(window).resize(function () {
//     adjustWidth();
// });

// $(document).ready(function () {
//     adjustWidth();
// });

$(".image-preview-input").change(function () {
    readURL(this);
});

// $(document.body).on('click', '.quiz-modal', function () {
//     adjustWidth();
// });

$(document.body).on('click', '.show-description', function () {
    if ($(this).hasClass('hide-description')) {
        $(this).closest('.row').next('.hide, .description-block').css('display', 'none');
        $(this).closest('.row').next('.show').css('display', 'block');
        $(this).removeClass('hide-description');
    } else {
        $(this).closest('.row').next('.hide, .description-block').css('display', 'block');
        $(this).closest('.row').next('.show').css('display', 'none');
        $(this).addClass('hide-description');
    }
});

function readURL(input) {
    if (input.files && input.files[0]) {
        const acceptedImageTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml'];
        if (!acceptedImageTypes.includes(input.files[0]['type'])) {
            return;
        }

        var reader = new FileReader();
        $('.image-preview').css('display', 'block');
        reader.onload = function (e) {
            $('.image-preview').attr('src', e.target.result);
        }

        reader.readAsDataURL(input.files[0]); // convert to base64 string
    }
}

$(document).ready(function () {
    $(document.body).on('mouseenter', '.action-link, .content-tile.w-inline-block, .hover-image, .hover-image-effect', function () {
        let inactive = $(this).find('.inactive-icon');
        let active = $(this).find('.active-icon');

        if (inactive.length && active.length) {
            $(inactive).css('opacity', '0');
        }
        if (active.length) {
            $(active).css('opacity', '1');
        }
    });

    $(document.body).on('mouseleave', '.action-link, .content-tile.w-inline-block, .hover-image, .hover-image-effect', function () {
        let inactive = $(this).find('.inactive-icon');
        let active = $(this).find('.active-icon');

        if (inactive.length) {
            $(inactive).css('opacity', '1');
        }
        if (active.length) {
            $(active).css('opacity', '0');
        }
    });

    $("#category-page #description").on('keyup', function () {
        if ($('#categoryDescriptionType').val() == 'words') {
            var words = this.value.match(/\S+/g).length;
            let lenght = $('#categoryDescriptionLenght').val();
            if (words > lenght) {
                var trimmed = $(this).val().split(/\s+/, lenght).join(" ");
                $(this).val(trimmed + " ");
            }
        }
    });
    $(".preview-file").click(function () {
        let url = $(this).data('url');
        let type = $(this).data('type');

        if (type == 'videos') {
            $('#previewLibraryModal video source').attr('src', url);
            $("#previewLibraryModal video")[0].load();
        }
        if (type == 'images') {
            $('#previewLibraryModal img').attr('src', url);
        }
        if (type == 'audio') {
            $('#previewLibraryModal audio').attr('src', url);
        }
        if (type == 'documents') {
            let extension = $(this).data('extension');
            let root = $(this).data('root');
            if (extension != 'pdf') {
                url = 'https://view.officeapps.live.com/op/embed.aspx?src=' + root + url;
            }
            $('#previewLibraryModal iframe').attr('src', url);
        }
        $('#previewLibraryModal').modal('show')
    });

    $('.delete-confirm').on('click', function (event) {
        event.preventDefault();
        let message1 = $(this).data('message1');
        let message2 = $(this).data('message2');
        const url = $(this).attr('href');
        swal.fire({
            title: message1,
            text: message2,
            icon: 'warning',
            confirmButtonText: window.trans.messages.Yes,
            cancelButtonText: window.trans.messages.No,
            showCancelButton: true,
            showCloseButton: true,
            reverseButtons: true,
            focusConfirm: false,
        }).then(function (result) {
            if (result.value) {
                window.location.href = url;
            }
        });
    });
});

function offsetAnchor() {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
    }
}

// Captures click events of all a elements with href starting with #
$(document).on('click', 'a[href^="#"]', function (event) {
    // Click events are captured before hashchanges. Timeout
    // causes offsetAnchor to be called after the page jump.
    window.setTimeout(function () {
        offsetAnchor();
    }, 0);
});
// Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);

//Set dropdown open on hover
function toggleDropdown(e) {
    const _d = $(e.target).closest('.dropdown');
    // const _m = $('.dropdown-menu', _d);
    const _m = _d.children('.dropdown-menu');
    setTimeout(function () {
        const shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 10 : 0);
}

// Retractable right side

function toggleRightSide() {
    document.querySelector(".middle-content")?.classList.toggle("add-to-middle");
    document.querySelector(".side-content.right")?.classList.toggle("remove-width-sides");
    document.querySelector(".btn-retractable-container-right")?.classList.toggle("hide-right-side")
}

function retractRightSide() {
    document.querySelector(".middle-content")?.classList.add("add-to-middle");
    document.querySelector(".side-content.right")?.classList.add("remove-width-sides");
    document.querySelector(".btn-retractable-container-right")?.classList.add("hide-right-side")
}

function expandRightSide() {
    document.querySelector(".middle-content")?.classList.remove("add-to-middle");
    document.querySelector(".side-content.right")?.classList.remove("remove-width-sides");
    document.querySelector(".btn-retractable-container-right")?.classList.remove("hide-right-side")
}

function toggleLeftSide() {
    document.querySelector(".side-content")?.classList.toggle("remove-width-sides");
    document.querySelectorAll('.side-content:not(.right) > div.fixed-parent').forEach(
        el => {
            el.classList.toggle('smooth-transition');
        }
    )

    document.querySelector(".btn-retractable-container-left")?.classList.toggle("hide-left-side")
}

function insertArrows() {
    const rightArrow = document.createElement("div");
    rightArrow.className = 'btn-retractable-container-right mobile-hide';
    rightArrow.innerHTML = '<img class="btn-retractable-right svg-with-hover" src="/images/svg-icons/marlms-slide-sidebar.svg"/>'
    document.querySelector(".side-content.right:not(.no-slide-button)")?.prepend(rightArrow);

    const leftArrow = document.createElement("div");
    leftArrow.className = 'btn-retractable-container-left mobile-hide';
    leftArrow.innerHTML = '<img class="btn-retractable-left svg-with-hover" src="/images/svg-icons/marlms-slide-sidebar.svg"/>'
    document.querySelector(".side-content:not(.right):not(.no-slide-button)")?.prepend(leftArrow);
}

$('body')
    .on('mouseenter mouseleave', '.dropdown', toggleDropdown)
    .on('click', '.dropdown-menu a', toggleDropdown)
    .on('click', '.btn-retractable-container-right', function () {
        toggleRightSide()
    })
    .on('click', '.btn-retractable-container-left', function () {
        toggleLeftSide()
    });

$(".header-draggable").on("touchstart", function(mousedownEvt) {
    var $draggable = $(this);
    var x = mousedownEvt.changedTouches[0].pageX - $draggable.offset().left,
        y = mousedownEvt.changedTouches[0].pageY - $draggable.offset().top;
    $draggable.on("touchmove", function(mousemoveEvt) {
        $draggable.closest(".modal-dialog").offset({
            "left": mousemoveEvt.originalEvent.targetTouches[0].pageX - x,
            "top": mousemoveEvt.originalEvent.targetTouches[0].pageY - y
        });
        $('body').css('overflow', 'hidden');
    });
    $draggable.on("touchend", function() {
        $('body').css('overflow', 'auto');
    });
});

(function ($) {
    $.fn.drags = function (opt) {

        opt = $.extend({handle: "", cursor: "move"}, opt);

        var $el = null;
        if (opt.handle === "") {
            $el = this;
        } else {
            $el = this.find(opt.handle);
        }

        return $el.css('cursor', opt.cursor).on("mousedown", function (e) {
            var $drag = null;
            if (opt.handle === "") {
                $drag = $(this).parents('.modal-dialog').addClass('draggable');
            } else {
                $drag = $(this).parents('.modal-dialog').addClass('active-handle').parent().addClass('draggable');
            }
            var z_idx = $drag.css('z-index'),
                drg_h = $drag.outerHeight(),
                drg_w = $drag.outerWidth(),
                pos_y = $drag.offset().top + drg_h - e.pageY,
                pos_x = $drag.offset().left + drg_w - e.pageX;
            $drag.css('z-index', 1000).parents().on("mousemove", function (e) {
                $('.draggable').offset({
                    top: e.pageY + pos_y - drg_h,
                    left: e.pageX + pos_x - drg_w
                }).on("mouseup", function () {
                    $(this).removeClass('draggable').css('z-index', z_idx);
                });
            });
            e.preventDefault(); // disable selection
        }).on("mouseup", function () {
            if (opt.handle === "") {
                $(this).parents('.modal-dialog').removeClass('draggable');
            } else {
                $(this).parents('.modal-dialog').removeClass('active-handle').parent().removeClass('draggable');
            }
        })
    }
    insertArrows();
    retractRightIfTabletPortrait();
    $('body').removeClass('is-loading');
})(jQuery);

$(window).on('resize', function () {
    retractRightIfTabletPortrait();
}).on('beforeunload', function () {
    $('body').addClass('is-loading');
});

function retractRightIfTabletPortrait() {
    const isRightSideRetracted = $('.side-content.right.remove-width-sides').length;
    if (!isRightSideRetracted && window.innerWidth < 991 && window.innerWidth >= 768) {
        retractRightSide();
    } else if (isRightSideRetracted && window.innerWidth >= 991) {
        expandRightSide();
    }
}

// This can be used to translate browser messages, but we should not

// $('input[type="text"], input[type="password"], input[type="number"], input[type="date"], input[type="email"]').each(function () {
//     $(this).on('invalid', function () {
//         this.setCustomValidity(trans['messages']['custom_validity'])
//     });
//     $(this).on('input', function () {
//         this.setCustomValidity('')
//     });
// });


var handle = null;
$(".modal-content.resize .modal-footer").on("touchstart gesturestart", function(e) {
    handle = {
        x : e.pageX,
        y : e.pageY,
        p : $(this).parent(),
        pw: $(this).parent().width(),
        ph: $(this).parent().height()
    };

    if (e.originalEvent.touches){
        handle.x = e.originalEvent.touches[0].pageX
        handle.y = e.originalEvent.touches[0].pageY
    }
});

$(document).on({
    'touchmove gesturechange':function(e){
        if(handle) {
            if (e.originalEvent.touches){ //e.touches
                handle.p.width(handle.pw+(e.originalEvent.touches[0].pageX - handle.x));
                handle.p.height(handle.ph+(e.originalEvent.touches[0].pageY - handle.y));
            } else{
                handle.p.width(handle.pw+(e.pageX - handle.x));
                handle.p.height(handle.ph+(e.pageY - handle.y));
            }
        }
    },
    'touchend gestureend':function(e){
        handle = null;
    }
});
